import React, { useMemo, useEffect, useState } from 'react'
import { Link, Route, Switch } from 'react-router-dom'
import Button from 'components/Button'
import useApi from 'hooks/useApi'
import useCurrentUser from 'hooks/useCurrentUser'

import Team from './components/Team'
import Teams from './components/Teams'
import InviteUserModal from './components/InviteUserModal'
import { Full as Loading } from 'components/Loading'

const CustomerTeamPage = ({ match: { isExact } }) => {
  const { roles } = useCurrentUser()
  const [customers, loading, errors, refetch] = useApi(`/rest/v2/customer`)
  const [, userAdded, addUserErrors, addUser] = useApi({ load: false })

  useEffect(() => {
    if (isExact || !userAdded) {
      refetch()
    }
  }, [isExact, userAdded])

  const users = useMemo(() => {
    return (customers || []).flatMap(({ contacts }) => contacts).filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj.uid).indexOf(obj.uid) === pos
    })
  }, [customers])

  if (!customers) {
    return (
      <Loading />
    )
  }

  const onUserAdded = (customerId, user) => {
    addUser(`/rest/v2/customer/${customerId}/contacts`, {
      method: 'PATCH',
      body: JSON.stringify([user]),
    })
  }

  const onUserRemoved = (customerId, user) => {
    addUser(`/rest/v2/customer/${customerId}/contacts`, {
      method: 'DELETE',
      body: JSON.stringify([user]),
    })
  }

  return (
    <div className="w-full h-full py-3 px-4 lg:py-5 lg:px-6">
      { roles.includes('organisation_manager') &&
        <Route exact path="/company/team/invite">
          { ({ match }) => (
            <InviteUserModal show={match && match.isExact ? true : false} />
          ) }
        </Route>
      }

      <Switch>
        <Route path="/company/team/:id/manage">
          { ({ match: { params: { id } } }) => (
            <Team
              onAdded={onUserAdded}
              onRemoved={onUserRemoved}
              editable={roles.includes('organisation_manager')}
              customer={customers.find(({ uid }) => uid == id)}
              users={users.filter(({ uid }) => !customers
                .find(({ uid }) => uid == id)
                .contacts.map(({ uid }) => uid)
                .includes(uid)
              )}
            />
          )}
        </Route>

        <Route path="/company/team">
          <Teams users={users} customers={customers} editable={roles.includes('organisation_manager')} />
        </Route>

      </Switch>
    </div>
  )
}

export default CustomerTeamPage
